import { createCachedColumnSelector } from './createCachedColumnSelector';

// hidden is optional; treat undefined and false both as "visible"
export const useVisibleColumns = createCachedColumnSelector(col => col.hidden !== true);